// extracted by mini-css-extract-plugin
export default {"ac-project-general":"ac-project-general_ac-project-general__YzIIZ"};